<template>
  <div
    v-if="html"
    v-html="html"
    :class="$style.googleDoc"
  />
</template>

<script>
import ViddseeLicensingQA from '../assets/ViddseeLicensingQA.module.html';

const iterateTag = elements => (handler) => {
  [...elements].forEach(handler);
};

const updateTag = (doc, source, target) => {
  const elements = doc.body.getElementsByTagName(source);
  iterateTag(elements)((element) => {
    element.className = target;
  });
};

export default {
  data() {
    return {
      html: null,
    };
  },
  mounted() {
    const parser = new DOMParser();
    const doc = parser.parseFromString(ViddseeLicensingQA, 'text/html');

    updateTag(doc, 'table', 'el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition');

    iterateTag(doc.body.getElementsByTagName('table'))((element) => {
      const tableWrapper = document.createElement('div');
      element.insertAdjacentElement('afterend', tableWrapper);
      tableWrapper.appendChild(element);
      tableWrapper.className = [
        this.$style.scrollableTableWrapper,
        this.$style.table,
      ].join(' ');
    });

    updateTag(doc, 'tbody', 'el-table__body');
    updateTag(doc, 'tr', 'el-table__row');
    updateTag(doc, 'td', 'cell');

    this.html = doc.body.innerHTML;
  },
};
</script>

<style lang="scss" module>
.scrollableTableWrapper {
  overflow: auto;
}

.table :global {
  .cell {
    word-break: normal;
    min-width: 160px;
  }
}

.googleDoc :global {
  h1 {
    font-size: 1.5rem;
  }
  h2 {
    font-size: 1rem;
  }
  h3 {
    font-size: 1rem;
    font-weight: normal;
    text-decoration: underline;
  }

  img {
    max-width: 100%;
    display: block;
  }

  td:nth-child(1),
  tr:nth-child(1) td {
    font-weight: bold;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/FrequentlyAskedQuestion/components/ViddseeLicensingQA.vue